import { httpRequest } from "../../http";
import { Vertical } from "@models/fieldMap.model";
export class CommandListVerticals {
  async run(): Promise<Vertical[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/`;
    return httpRequest<Vertical[]>(url, { method: "GET" });
  }
}
